import React from 'react';
import { FaUserFriends, FaWindowClose } from 'react-icons/fa';
import { peerlessDataForMembers } from './PeerlessData';
import Slider from 'react-slick';

const Team = ({setNavLinks, slidesToShow3, setSlidesToShow3, isWindowReduced}) => {


    React.useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth >= 1030) {
            setSlidesToShow3(3);
          } else if (window.innerWidth >= 600) {
            setSlidesToShow3(2);
          } else if (window.innerWidth >= 300) {
            setSlidesToShow3(1);
          } else {
            setSlidesToShow3(1);
          }
    
          
        };
    
        handleResize()
        window.addEventListener('resize', handleResize);
        
        // Clean up the event listener when the component unmounts
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, [setSlidesToShow3]);
    
    
    
        const settings = {
    
            dots: false,
            infinity: true,
            slidesToShow: slidesToShow3,
            slidesToScroll: 1,
            lazyLoad: true,
            autoplaySpeed: 2000,
        
       
        }
    
  return (
    <div className='container-fluid'> 
           <div className='close-window-icon' >
            <FaWindowClose color='#1b2328' onClick={()=>{
              
              setNavLinks({aboutLink: true})
              sessionStorage.setItem("currentSession", JSON.stringify({aboutLink: true}));
              }}/> 
           </div>
           
          <h1 className='title'>
            <FaUserFriends color='#1b2328' /> 
            Our Team 
          </h1>


          <div className='members-container'>

        <Slider {...settings}>

          {

            peerlessDataForMembers.map((members) => {

               return(

                    <article className='member-profile' key={members.id}>

                        <div className='members-img-container'>
                            <img src={require(`../Images/Members/${members.image}`)} alt=''/>
                        </div>
                        <div className='nameOfMember'>

                          <h3>{members.nameOfMember}</h3>

                        </div>
                        <div className='serviceName'>

                            <p>{members.serviceName}</p>

                        </div>

                    </article>

                      
               )
            })
          }

          </Slider>
          {isWindowReduced && <p className='d-flex justify-content-center custom-info'> Slide to see more </p>}


        </div>
         
    </div>
  )
}

export default Team;